"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_TYPES = void 0;
var CHANNEL_TYPES;
(function (CHANNEL_TYPES) {
    CHANNEL_TYPES["CHANNEL"] = "channel";
    CHANNEL_TYPES["YOUTUBE_FEED"] = "youtube-feed";
})(CHANNEL_TYPES = exports.CHANNEL_TYPES || (exports.CHANNEL_TYPES = {}));
//# sourceMappingURL=channel-types.js.map